import axios from "axios";
import { useEffect, useState } from "react";
import {
  deleteData,
  getData,
  postData,
  postRawData,
  putData,
  patchData,
} from "./url-request";

import * as url from "./url_helper";
import { getAuthenticatedUser } from "./auth-session";

export const getOnboardingPreference = () => getData("/me/onboarding");
export { getGettingStartedStatus } from "./getting-started-request";
export const getDashboardReadiness = () => getData("/me/dashboard-readiness");
export const updateOnboardingPreference = (data) =>
  patchData("/me/onboarding", data);
export const getOnboardingCatalogue = () => getData("/me/onboarding/catalogue");
export const saveOnboardingCatalogueDraft = (data) =>
  putData("/me/onboarding/catalogue/draft", data);
export const provisionOnboardingCatalogue = (data) =>
  postData("/me/onboarding/catalogue/provision", data);
export const getOnboardingFirmProfile = () =>
  getData("/me/onboarding/firm-profile");
export const updateOnboardingFirmProfile = (data) =>
  putData("/me/onboarding/firm-profile", data);

export const deleteAdminData = (dataType, id) =>
  deleteData(`/admin/lifecycle/${dataType}/${id}`);
export const archiveAdminData = (dataType, id, firmId) =>
  postData(`/admin/lifecycle/${dataType}/${id}/archive${firmId ? `?firmId=${firmId}` : ""}`, {});
export const restoreAdminData = (dataType, id, firmId) =>
  postData(`/admin/lifecycle/${dataType}/${id}/restore${firmId ? `?firmId=${firmId}` : ""}`, {});

// Gets the logged in user data from local session
export const getLoggedInUser = async () => {
  return getLocalStorage();
};

//is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

export const getLocalStorage = () => {
  return getAuthenticatedUser();
};

export const provisionActiveFirmCatalogues = () =>
  postData(url.PROVISION_ACTIVE_FIRM_CATALOGUES, {});

// Location API Request
export const getCompanyLocations = async () => {
  return await getData(url.GET_LOCATIONS + "/" + 0);
};

export const getCompanySpecificLocations = async (companyId) => {
  return await getData(url.GET_LOCATIONS + "/" + companyId);
};

export const getUserLocations = async () => {
  return await getData(url.GET_USER_LOCATIONS);
};

export const getCompanyLocationById = async (Id) => {
  return await getData(url.GET_LOCATION + Id);
};

export const createUpdateLocation = async (locationData) => {
  return await postData(url.CREATEUPDATE_LOCATION, locationData);
};

//Checklist

export const getChecklists = (includeInactive = false) => {
  return getData(
    url.GET_CHECKLIST_LIST + (includeInactive ? "?includeInactive=true" : "")
  );
};

export const createChecklist = async (data) => {
  return await postData(url.CREATE_CHECKLIST, data);
};

export const updateChecklist = async (data) => {
  return await postData(url.UPDATE_CHECKLIST, data);
};

export const getChecklistDetail = async (id) => {
  return await getData(url.GET_CHECKLIST_DETAIL + "/" + id);
};

export const deleteChecklist = async (id) => {
  return await deleteData(url.DELETE_CHECKLIST + "/" + id);
};

export const getReferencelists = () => {
  return getData(url.GET_REFERENCE_LIST);
};

export const createReference = async (data) => {
  return await postData(url.CREATE_REFERENCE, data);
};

export const updateReference = async (data) => {
  return await postData(url.UPDATE_REFERENCE, data);
};

export const getReferenceDetail = async (id) => {
  return await getData(url.GET_REFERENCE_DETAIL + "/" + id);
};

export const getArealists = (includeInactive = false) => {
  return getData(
    url.GET_AREA_LIST + (includeInactive ? "?includeInactive=true" : "")
  );
};

export const createArea = async (data) => {
  return await postData(url.CREATE_AREA, data);
};

export const updateArea = async (data) => {
  return await postData(url.UPDATE_AREA, data);
};

export const getAreaDetail = async (id) => {
  return await getData(url.GET_AREA_DETAIL + "/" + id);
};

export const getTopiclists = (includeInactive = false) => {
  return getData(
    url.GET_TOPIC_LIST + (includeInactive ? "?includeInactive=true" : "")
  );
};

export const createTopic = async (data) => {
  return await postData(url.CREATE_TOPIC, data);
};

export const updateTopic = async (data) => {
  return await postData(url.UPDATE_TOPIC, data);
};

export const getTopicDetail = async (id) => {
  return await getData(url.GET_TOPIC_DETAIL + "/" + id);
};

export const getQuestionlists = async (checklistId) => {
  return await getData(url.GET_QUESTION_LIST + "/" + checklistId);
};

export const createQuestion = async (data) => {
  return await postData(url.CREATE_QUESTION, data);
};

export const updateQuestion = async (data) => {
  return await postData(url.UPDATE_QUESTION, data);
};

export const getQuestionDetail = async (id) => {
  return await getData(url.GET_QUESTION_DETAIL + "/" + id);
};

export const deleteQuestion = async (id) => {
  return await deleteData(url.DELETE_QUESTION + "/" + id);
};

//standards & service codes

export const getStandardTypes = () => {
  return getData(url.GET_STANDARDS_LIST);
};

export const createStandard = async (data) => {
  return await postData(url.CREATE_STANDARD, data);
};

export const updateStandard = async (data) => {
  return await postData(url.UPDATE_STANDARD, data);
};

export const getStandardDetail = async (id) => {
  return await getData(url.GET_STANDARD_DETAIL + "/" + id);
};

export const getServiceCodeList = () => {
  return getData(url.GET_SERVICECODE_LIST);
};

export const createServiceCode = async (data) => {
  return await postData(url.CREATE_SERVICECODE, data);
};

export const updateServiceCode = async (data) => {
  return await postData(url.UPDATE_SERVICECODE, data);
};

export const getServiceCodeDetail = async (id) => {
  return await getData(url.GET_SERVICECODE_DETAIL + "/" + id);
};

export const getMandatoryServiceCodeList = () => {
  return getData(url.GET_MANDATORYSERVICECODE_LIST);
};

export const createMandatoryServiceCode = async (data) => {
  return await postData(url.CREATE_MANDATORYSERVICECODE, data);
};

export const updateMandatoryServiceCode = async (data) => {
  return await postData(url.UPDATE_MANDATORYSERVICECODE, data);
};

export const getMandatoryServiceCodeDetail = async (id) => {
  return await getData(url.GET_MANDATORYSERVICECODE_DETAIL + "/" + id);
};

//financial year
export const getFinancialYearList = () => {
  return getData(url.GET_FINANCIALYEAR_LIST);
};

export const createFinancialYear = async (data) => {
  return await postData(url.CREATE_FINANCIALYEAR, data);
};

export const updateFinancialYear = async (data) => {
  return await postData(url.UPDATE_FINANCIALYEAR, data);
};

export const getFinancialYearDetail = async (id) => {
  return await getData(url.GET_FINANCIALYEAR_DETAIL + "/" + id);
};

//Review Templates
export const getReviewTemplateList = (includeInactive = false) => {
  return getData(
    url.GET_REVIEWTEMPLATE_LIST +
      (includeInactive ? "?includeInactive=true" : "")
  );
};

export const createReviewTemplate = async (data) => {
  return await postData(url.CREATE_REVIEWTEMPLATE, data);
};

export const updateReviewTemplate = async (data) => {
  return await postData(url.UPDATE_REVIEWTEMPLATE, data);
};

export const getReviewTemplateDetail = async (id) => {
  return await getData(url.GET_REVIEWTEMPLATE_DETAIL + "/" + id);
};

export const getReviewTemplateConfiguration = (id, versionId) =>
  getData(
    `${url.REVIEWTEMPLATE_CONFIGURATION}/${id}/configuration${
      versionId ? `?versionId=${versionId}` : ""
    }`
  );

export const saveReviewTemplateConfiguration = (id, configuration) =>
  putData(
    `${url.REVIEWTEMPLATE_CONFIGURATION}/${id}/configuration`,
    configuration
  );

export const publishReviewTemplate = (id) =>
  postData(`${url.REVIEWTEMPLATE_CONFIGURATION}/${id}/publish`, {});

export const createReviewTemplateDraftVersion = (id) =>
  postData(`${url.REVIEWTEMPLATE_CONFIGURATION}/${id}/create-version`, {});

export const duplicateReviewTemplate = (id) =>
  postData(`${url.REVIEWTEMPLATE_CONFIGURATION}/${id}/duplicate`, {});

export const getReviewTemplateVersionList = async (templateId) => {
  return getData(url.GET_REVIEWTEMPLATEVERSION_LIST + "/" + templateId);
};

export const createReviewTemplateVersion = async (data) => {
  return await postData(url.CREATE_REVIEWTEMPLATEVERSION, data);
};

export const updateReviewTemplateVersion = async (data) => {
  return await postData(url.UPDATE_REVIEWTEMPLATEVERSION, data);
};

export const getReviewTemplateVersionDetail = async (id) => {
  return await getData(url.GET_REVIEWTEMPLATEVERSION_DETAIL + "/" + id);
};

export const getReviewTemplateFieldList = async (templateId, versionId) => {
  return getData(
    url.GET_REVIEWTEMPLATEFIELD_LIST + "/" + templateId + "/" + versionId
  );
};

export const createReviewTemplateField = async (data) => {
  return await postData(url.CREATE_REVIEWTEMPLATEFIELD, data);
};

export const updateReviewTemplateField = async (data) => {
  return await postData(url.UPDATE_REVIEWTEMPLATEFIELD, data);
};

export const getReviewTemplateFieldDetail = async (id) => {
  return await getData(url.GET_REVIEWTEMPLATEFIELD_DETAIL + "/" + id);
};

//data import
export const getDataImportMappings = (mappingId) => {
  return getData(url.GET_DATAIMPORTMAPPING_LIST + "/" + mappingId);
};

export const getDataImports = () => {
  return getData(url.GET_DATAIMPORT_LIST);
};

export const getDataImportReport = (importId) => {
  return getData(url.GET_DATAIMPORT_REPORT + "/" + importId);
};

//master
export const getDataImportTypes = () => {
  return getData(url.GET_DATAIMPORTTYPE_LIST);
};

export const getClientTypes = (includeInactive = false) => {
  return getData(
    url.GET_CLIENTTYPE_LIST + (includeInactive ? "?includeInactive=true" : "")
  );
};

export const getIndustryTypes = (includeInactive = false) => {
  return getData(
    url.GET_INDUSTRYTYPE_LIST + (includeInactive ? "?includeInactive=true" : "")
  );
};

export const getWorkTypes = (includeInactive = false) => {
  return getData(
    url.GET_WORKTYPE_LIST + (includeInactive ? "?includeInactive=true" : "")
  );
};

export const getRisks = (includeInactive = false) =>
  getData(
    `${url.GET_RISK_LIST}${includeInactive ? "?includeInactive=true" : ""}`
  );
export const getRiskCategories = () => getData(url.GET_RISKCATEGORY_LIST);
export const createUpdateRisk = (_data) =>
  postData(url.CREATEUPDATE_RISK, _data);

export const getReportTemplates = () => getData(url.REPORT_TEMPLATE_LIST);
export const getReportTemplateLookups = () =>
  getData(url.REPORT_TEMPLATE_LOOKUPS);
export const getReportTemplate = (id) =>
  getData(`${url.REPORT_TEMPLATE_LIST}/${id}`);
// The API owns the template identifier. Do not post an empty client-side identifier on first save.
export const createReportTemplate = ({ id, guid, rowVersion, ...data }) =>
  postData(url.REPORT_TEMPLATE_LIST, data);
export const saveReportTemplateBasic = (id, data) =>
  putData(`${url.REPORT_TEMPLATE_LIST}/${id}/basic-information`, data);
export const saveReportTemplateSections = (id, sections) =>
  putData(`${url.REPORT_TEMPLATE_LIST}/${id}/sections`, sections);
export const saveReportTemplateStyles = (id, style) =>
  putData(`${url.REPORT_TEMPLATE_LIST}/${id}/styles`, style);
export const publishReportTemplate = (id) =>
  postData(`${url.REPORT_TEMPLATE_LIST}/${id}/publish`, {});
export const createReportTemplateVersion = (id) =>
  postData(`${url.REPORT_TEMPLATE_LIST}/${id}/create-version`, {});

export const getInspectionTypes = () => {
  return getData(url.GET_INSPECTIONTYPE_LIST);
};

export const createUpdateWorkType = (data) =>
  postData(url.CREATEUPDATE_WORKTYPE, data);
export const createUpdateClientType = (data) =>
  postData(url.CREATEUPDATE_CLIENTTYPE, data);
export const createUpdateIndustryType = (data) =>
  postData(url.CREATEUPDATE_INDUSTRYTYPE, data);

export const createUpdateMeetingCategory = async (_data) => {
  return await postData(url.CREATEUPDATE_MEETINGCATEGORY, _data);
};

export const getDealTypes = () => {
  return getData(url.GET_DEALTYPE_LIST);
};

export const getDealStatues = () => {
  return getData(url.GET_DEALSTATUS_LIST);
};

export const getCallTypes = () => {
  return getData(url.GET_CALLTYPE_LIST);
};

export const getCallOutcomes = () => {
  return getData(url.GET_CALLOUTCOME_LIST);
};

export const getLeadSources = () => {
  return getData(url.GET_LEADSOURCE_LIST);
};

export const getLeadStatues = () => {
  return getData(url.GET_LEADSTATUS_LIST);
};

export const getAccountTypes = async () => {
  return await getData(url.GET_ACCOUNTTYPE_LIST);
};

export const getAccountStatuses = async () => {
  return await getData(url.GET_ACCOUNTSTATUS_LIST);
};

export const getMeetingCategories = () => {
  return getData(url.GET_MEETINGCATEGORY_LIST);
};

export const getMeetingTypes = async () => {
  return await getData(url.GET_MEETINGTYPES_LIST);
};

export const getMeetingStatuses = async () => {
  return await getData(url.GET_MEETINGSTATUS_LIST);
};

export const getMeetingSubStatuses = async () => {
  return await getData(url.GET_MEETINGSUBSTATUS_LIST);
};

export const getMeetingPriorities = async () => {
  return await getData(url.GET_MEETINGPRIORITY_LIST);
};

export const createUpdateCategory = async (_data) => {
  return await postData(url.CREATEUPDATE_CATEGORY, _data);
};

export const getCategory = async () => {
  return await getData(url.GET_CATEGORY_LIST);
};

export const getSubCategory = async (catId) => {
  return await getData(url.GET_SUBCATEGORY_LIST + "/" + catId);
};

export const createUpdateSubCategory = async (_data) => {
  return await postData(url.CREATEUPDATE_SUBCATEGORY, _data);
};

export const getTagList = async () => {
  return await getData(url.GET_TAG_LIST);
};

export const createUpdateTag = async (_data) => {
  return await postData(url.CREATEUPDATE_TAG, _data);
};

export const getLevelList = async () => {
  return await getData(url.GET_LEVEL_LIST);
};

export const getInspectionCycleStatusList = async () => {
  return await getData(url.GET_INSPECTION_CYCLE_STATUS_LIST);
};

export const getInspectionCycleTypeList = async () => {
  return await getData(url.GET_INSPECTION_CYCLE_TYPES_LIST);
};

//master folder
export const getFolderList = async () => {
  return await getData(url.GET_FOLDER_LIST);
};

export const getFolderTree = async () => {
  return await getData(url.GET_FOLDER_TREE);
};

export const createFolder = async (data) => {
  return await postData(url.POST_FOLDER_CREATE, data);
};

//engagements
export const getEngagementList = async () => {
  return await getData(url.GET_ENGAGEMENTLIST);
};

export const getUnassignedEngagementList = async () => {
  return await getData(url.GET_UNASSIGNEDENGAGEMENTLIST);
};

export const assignEngagementsToInspectionCycle = async (_data) => {
  return await postData("/engagement/assign-to-inspection-cycle", _data);
};

export const getUnGeneratedEngagementList = async () => {
  return await getData(url.GET_UNGENERATEDENGAGEMENTLIST);
};

export const createEngagement = async (_data) => {
  return await postData(url.CREATE_ENGAGEMENT, _data);
};

export const updateEngagement = async (_data) => {
  return await postData(url.UPDATE_ENGAGEMENT, _data);
};

export const updateEngagementDetails = async (_data) => {
  return await postData(url.UPDATE_ENGAGEMENT_DETAILS, _data);
};

export const updateEngagementBasic = (data) =>
  postData("/engagement/update-basic", data);

export const saveEngagementDraft = (data) =>
  postData("/engagement/save-draft", data);

export const assignEngagementDataPreparation = async (_data) => {
  return await postData("/engagement/assign-data-preparation", _data);
};

export const uploadEngagementDocuments = async (formData) => {
  return await postRawData(url.ADD_ENGAGEMENT_DOCUMENT, "POST", formData);
};

export const getEngagementDocuments = async (
  engagementId,
  inspectionReviewId = null
) => {
  const query = inspectionReviewId
    ? `?inspectionReviewId=${encodeURIComponent(inspectionReviewId)}`
    : "";
  return await getData(
    `${url.GET_ENGAGEMENT_DOCUMENTS}/${engagementId}${query}`
  );
};

export const getEngagementDocumentFolders = async (
  engagementId,
  inspectionReviewId = null
) => {
  const query = inspectionReviewId
    ? `?inspectionReviewId=${encodeURIComponent(inspectionReviewId)}`
    : "";
  return getData(
    `${url.GET_ENGAGEMENT_DOCUMENT_FOLDERS}/${engagementId}${query}`
  );
};

export const createEngagementDocumentFolder = async (folder) =>
  postData(url.CREATE_ENGAGEMENT_DOCUMENT_FOLDER, folder);

export const updateEngagementDocument = async (documentId, formData) => {
  return await postRawData(
    `${url.UPDATE_ENGAGEMENT_DOCUMENT}/${documentId}`,
    "POST",
    formData
  );
};

export const deleteEngagementDocument = async (documentId) => {
  return await deleteData(`${url.DELETE_ENGAGEMENT_DOCUMENT}/${documentId}`);
};

export const getEngagementDetail = async (id) => {
  return await getData(url.GET_ENGAGEMENTDETAIL + "/" + id);
};

export const generateEngagementInspection = async (_data) => {
  return await postData(url.GENERATE_ENGAGEMENTINSPECTION, _data);
};

export const getEngagementReviewReadiness = async (id) => {
  return await getData(`${url.GET_ENGAGEMENT_REVIEW_READINESS}/${id}`);
};

export const deleteEngagement = async (id) => {
  return await deleteData(`${url.DELETE_ENGAGEMENT}/${id}`);
};

export const getEngagementActivityList = async (engagementId) => {
  return await getData(url.GET_ENGAGEMENTACTIVITYLIST + "/" + engagementId);
};

//inspections
export const getInspectionList = async (inspectionId) => {
  return await getData(inspectionId ? `${url.GET_INSPECTIONLIST}?inspectionId=${encodeURIComponent(inspectionId)}` : url.GET_INSPECTIONLIST);
};

// Cycle-engagement configuration creates executable reviews directly.
export const getCycleEngagements = (cycleId) =>
  getData(`/inspection-cycle-engagements/cycle/${cycleId}`);
export const attachEngagementsToCycle = (cycleId, engagementIds) =>
  postData(`/inspection-cycle-engagements/cycle/${cycleId}`, { engagementIds });
export const getCycleEngagementConfiguration = (id) =>
  getData(`/inspection-cycle-engagements/${id}/configuration`);
export const selectCycleEngagementTemplate = (id, reviewTemplateId) =>
  putData(`/inspection-cycle-engagements/${id}/template`, { reviewTemplateId });
export const saveCycleEngagementChecklists = (id, checklistIds) =>
  putData(`/inspection-cycle-engagements/${id}/checklists`, { checklistIds });
export const saveCycleEngagementAssignments = (id, assignments) =>
  putData(`/inspection-cycle-engagements/${id}/assignments`, { assignments });
export const createCycleEngagementReview = (id) =>
  postData(`/inspection-cycle-engagements/${id}/create-review`, {});
export const removeCycleEngagement = (id) =>
  deleteData(`/inspection-cycle-engagements/${id}`);

// Legacy planning helpers remain only for old clients; the API no longer exposes these routes.
export const getEngagementInspections = (engagementId) =>
  getData(`/inspections/engagement/${engagementId}`);
export const getInspectionSetup = (engagementId) =>
  getData(`/inspections/engagement/${engagementId}/setup`);
export const getInspectionPlanList = () => getData("/inspections");
export const getInspectionPreparationAssignees = () =>
  getData("/inspections/assignees");
export const getInspectionPlan = (inspectionId) =>
  getData(`/inspections/${inspectionId}`);
export const saveInspectionPlan = (data) => postData("/inspections", data);
export const createInspectionReviews = (inspectionId) =>
  postData(`/inspections/${inspectionId}/create-reviews`, {});
export const assignInspectionPreparation = (inspectionId, assignedTo, notes) =>
  postData(`/inspections/${inspectionId}/assign-preparation`, {
    assignedTo,
    notes,
  });
export const abortInspectionPlan = (inspectionId, reason) =>
  postData(`/inspections/${inspectionId}/abort`, { reason });
export const uploadInspectionPlanDocuments = (inspectionId, formData) =>
  postRawData(`/inspections/${inspectionId}/documents`, "POST", formData);

export const getMyInspectionList = async () => {
  return await getData(url.GET_UNASSIGNEDENGAGEMENTLIST);
};

export const getInspectionChecklist = async (inspectionId) => {
  return await getData(url.GET_INSPECTIONCHECKLIST + "/" + inspectionId);
};
export const startInspectionReview = (inspectionId) =>
  postData(`/inspection/${inspectionId}/start`, {});
export const updateInspectionAssignment = (inspectionId, assignedTo) =>
  putData(`/inspection/${inspectionId}/assignment`, { assignedTo });
export const saveInspectionChecklistResponse = (
  inspectionId,
  inspectionChecklistId,
  data
) =>
  putData(
    `/inspection/${inspectionId}/checklist/${inspectionChecklistId}/response`,
    data
  );
export const submitInspectionForApproval = (inspectionId) =>
  postData(`/inspection/${inspectionId}/submit-for-approval`, {});
export const approveInspection = (inspectionId) =>
  postData(`/inspection/${inspectionId}/approve`, {});
export const returnInspectionForChanges = (inspectionId) =>
  postData(`/inspection/${inspectionId}/return-for-changes`, {});
export const getInspectionApprovalPermission = (inspectionId) =>
  getData(`/inspection/${inspectionId}/approval-permission`);
export const getInspectionReviewWorkflowTasks = (inspectionId) =>
  getData(`/inspection/${inspectionId}/workflow-tasks`);
export const getMyInspectionReviewTasks = () =>
  getData("/inspection/review-tasks/mine");
export const reassignInspectionReviewWorkflowTask = (
  inspectionId,
  workflowTaskId,
  assignedTo
) =>
  putData(
    `/inspection/${inspectionId}/workflow-tasks/${workflowTaskId}/assignment`,
    { assignedTo }
  );
export const completeInspectionReviewWorkflowTask = (
  inspectionId,
  workflowTaskId
) =>
  postData(
    `/inspection/${inspectionId}/workflow-tasks/${workflowTaskId}/complete`,
    {}
  );
export const saveInspectionChecklistSignOffComment = (
  inspectionId,
  workflowTaskId,
  inspectionChecklistId,
  comments
) =>
  putData(
    `/inspection/${inspectionId}/workflow-tasks/${workflowTaskId}/checklist/${inspectionChecklistId}/sign-off-comment`,
    { comments }
  );
export const reopenInspectionChecklistQuestionForReview = (
  inspectionId,
  workflowTaskId,
  inspectionChecklistId,
  comments
) =>
  postData(
    `/inspection/${inspectionId}/workflow-tasks/${workflowTaskId}/checklist/${inspectionChecklistId}/reopen-for-review`,
    { comments }
  );

export const getInspectionChecklistBookmarks = (inspectionId) =>
  getData(`/inspection/${inspectionId}/bookmarks`);
export const setInspectionChecklistBookmark = (
  inspectionId,
  inspectionChecklistId,
  isBookmarked
) =>
  putData(`/inspection/${inspectionId}/bookmarks/${inspectionChecklistId}`, {
    isBookmarked,
  });
export const getInspectionChecklistQueries = (
  inspectionId,
  inspectionChecklistId,
  queryId
) =>
  getData(
    `/inspection/${inspectionId}/queries${
      inspectionChecklistId
        ? `?inspectionChecklistId=${inspectionChecklistId}`
        : ""
    }${queryId ? `${inspectionChecklistId ? "&" : "?"}queryId=${queryId}` : ""
    }`
  );
export const createInspectionChecklistQuery = (inspectionId, data) =>
  postData(`/inspection/${inspectionId}/queries`, data);
export const updateInspectionChecklistQuery = (inspectionId, queryId, data) =>
  putData(`/inspection/${inspectionId}/queries/${queryId}`, data);
export const deleteInspectionChecklistQuery = (inspectionId, queryId) =>
  deleteData(`/inspection/${inspectionId}/queries/${queryId}`);
export const respondToInspectionChecklistQuery = (
  inspectionId,
  queryId,
  data
) => postData(`/inspection/${inspectionId}/queries/${queryId}/response`, data);
export const closeInspectionChecklistQuery = (inspectionId, queryId) =>
  postData(`/inspection/${inspectionId}/queries/${queryId}/close`, {});
export const getQueryResponseReview = (inspectionId, queryId) =>
  getData(`/inspection/${inspectionId}/queries/${queryId}/response-review`);
export const updateQueryResponseReview = (inspectionId, queryId, action, data) =>
  postData(`/inspection/${inspectionId}/queries/${queryId}/response-review/${action}`, data);
export const uploadInspectionChecklistQueryAttachment = (
  inspectionId,
  queryId,
  formData
) =>
  postRawData(
    `/inspection/${inspectionId}/queries/${queryId}/attachments`,
    "POST",
    formData
  );
export const getInspectionChecklistDiscussions = (
  inspectionId,
  inspectionChecklistId
) =>
  getData(
    `/inspection/${inspectionId}/discussions${inspectionChecklistId == null ? "" : `?inspectionChecklistId=${inspectionChecklistId}`}`
  );
export const createInspectionChecklistDiscussion = (inspectionId, data) =>
  postData(`/inspection/${inspectionId}/discussions`, data);
export const getDiscussionMentionUsers = (inspectionId) =>
  getData(`/inspection/${inspectionId}/discussion-mention-users`);
export const addInspectionChecklists = (inspectionId, checklistIds) =>
  postData(`/inspection/${inspectionId}/checklists`, { checklistIds });
export const uploadInspectionChecklistDiscussionAttachment = (
  inspectionId,
  discussionId,
  formData
) =>
  postRawData(
    `/inspection/${inspectionId}/discussions/${discussionId}/attachments`,
    "POST",
    formData
  );

export const getInspectionActivities = (inspectionId) =>
  getData(`/inspection/${inspectionId}/activities`);
export const addInspectionActivity = (inspectionId, activityNote) =>
  postData(`/inspection/${inspectionId}/activities`, { activityNote });

export const getInspectionFindingConfiguration = (inspectionId) =>
  getData(`/inspection/${inspectionId}/finding-configuration`);
export const getInspectionFindings = (inspectionId, questionId) =>
  getData(
    `/inspection/${inspectionId}/findings${
      questionId ? `?questionId=${questionId}` : ""
    }`
  );
export const getInspectionFinding = (inspectionId, findingId) =>
  getData(`/inspection/${inspectionId}/findings/${findingId}`);
export const createInspectionFinding = (inspectionId, data) =>
  postData(`/inspection/${inspectionId}/findings`, data);
export const updateInspectionFinding = (inspectionId, findingId, data) =>
  putData(`/inspection/${inspectionId}/findings/${findingId}`, data);
export const saveInspectionFindingManagementResponse = (
  inspectionId,
  findingId,
  data
) =>
  putData(
    `/inspection/${inspectionId}/findings/${findingId}/management-response`,
    data
  );
export const addInspectionFindingMessage = (inspectionId, findingId, data) =>
  postData(`/inspection/${inspectionId}/findings/${findingId}/messages`, data);
export const transitionInspectionFinding = (inspectionId, findingId, data) =>
  postData(
    `/inspection/${inspectionId}/findings/${findingId}/transition`,
    data
  );
export const deleteInspectionFinding = (inspectionId, findingId) =>
  deleteData(`/inspection/${inspectionId}/findings/${findingId}`);
export const getInspectionEvidence = (inspectionId, inspectionChecklistId, includeFindingAttachments = false) =>
  getData(
    `/inspection/${inspectionId}/evidence?inspectionChecklistId=${inspectionChecklistId}${includeFindingAttachments ? "&includeFindingAttachments=true" : ""}`
  );
export const getInspectionEvidenceCount = (inspectionId) =>
  getData(`/inspection/${inspectionId}/evidence/count`);
export const getChecklistEvidence = (inspectionId, checklistId) =>
  getData(`/inspection/${inspectionId}/evidence?checklistId=${checklistId}&includeFindingAttachments=true`);
export const getInspectionGeneratedReports = (inspectionId) =>
  getData(`/inspection/${inspectionId}/reports`);
export const getInspectionReviewDocuments = (inspectionId) =>
  getData(`/inspection/${inspectionId}/documents`);
export const uploadInspectionReviewDocuments = (inspectionId, formData) =>
  postRawData(`/inspection/${inspectionId}/documents`, "POST", formData);

const fetchInspectionDocument = async (inspectionId, documentId) => {
  const response = await fetch(
    `${url.BASE_URL}/inspection/${inspectionId}/evidence/${documentId}/download`,
    {
      credentials: "include",
    }
  );
  if (!response.ok) throw new Error("Unable to retrieve the generated report.");
  return response.blob();
};

export const downloadInspectionDocument = async (
  inspectionId,
  documentId,
  fileName = "report.pdf"
) => {
  const blob = await fetchInspectionDocument(inspectionId, documentId);
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
};

export const previewInspectionDocument = async (inspectionId, documentId) => {
  const previewWindow = window.open("", "_blank");
  if (!previewWindow)
    throw new Error("Allow pop-ups to preview this generated report.");
  try {
    const blob = await fetchInspectionDocument(inspectionId, documentId);
    const objectUrl = URL.createObjectURL(blob);
    previewWindow.location.href = objectUrl;
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  } catch (error) {
    previewWindow.close();
    throw error;
  }
};
export const uploadInspectionEvidence = (inspectionId, formData) =>
  postRawData(`/inspection/${inspectionId}/evidence`, "POST", formData);
export const deleteInspectionEvidence = (inspectionId, documentId) =>
  deleteData(`/inspection/${inspectionId}/evidence/${documentId}`);

//leads
export const getActiveLeads = async (data) => {
  return await postData(url.POST_LEAD_SEARCH, data);
};

export const getLeadDocuments = async (leadId) => {
  return await getData(url.GET_LEAD_DOCUMENT + "/" + leadId);
};

export const getLeadCalllogs = async (leadId) => {
  return await getData(url.GET_LEAD_CALLLOG + "/" + leadId);
};

export const getLeadNotes = async (leadId) => {
  return await getData(url.GET_LEAD_NOTES + "/" + leadId);
};

//contacts
export const getContacts = async (data) => {
  return await postData(url.POST_CONTACT_SEARCH, data);
};

//sales accounts
export const getActiveAccounts = async (data) => {
  return await postData(url.POST_SALESACCOUNT_SEARCH, data);
};

//Sales Deals
export const getSalesDeals = async (data) => {
  return await postData(url.POST_DEAL_SEARCH, data);
};

//meetings
export const getAllMeetings = async () => {
  return await getData(url.GET_ALL_MEETINGS);
};

export const getActiveMeetings = async () => {
  return await getData(url.GET_ACTIVE_MEETINGS);
};

export const getPastMeetings = async () => {
  return await getData(url.GET_PAST_MEETINGS);
};

export const getMeetingDetails = async (id) => {
  return await getData(url.GET_MEETING_DETAIL + "/" + id);
};

export const getMeetingAgenda = async (id) => {
  return await getData(url.GET_MEETING_AGENDA + "/" + id);
};

export const getMeetingNotes = async (id) => {
  return await getData(url.GET_MEETING_NOTES + "/" + id);
};

export const getMeetingSummary = async (id) => {
  return await getData(url.GET_MEETING_SUMMARY + "/" + id);
};

export const getMeetingComments = async (id) => {
  return await getData(url.GET_MEETING_COMMENTS + "/" + id);
};

export const getMeetingDocs = async (id) => {
  return await getData(url.GET_MEETING_DOCUMENTS + "/" + id);
};

export const getPreviousMeetings = async (id) => {
  return await getData(url.GET_MEETING_PREVIOUSMEETINGS + "/" + id);
};

export const getFollowupMeetings = async (id) => {
  return await getData(url.GET_MEETING_FOLLOWUPMEETINGS + "/" + id);
};

export const getAgendaDetail = async (agendaId) => {
  return await getData(url.GET_MEETING_AGENDADETAIL + "/" + agendaId);
};

export const getAgendaComments = async (agendaId) => {
  return await getData(url.GET_MEETING_AGENDACOMMENTS + "/" + agendaId);
};

export const getAgendaDocs = async (agendaId) => {
  return await getData(url.GET_MEETING_AGENDADOCS + "/" + agendaId);
};

export const getAgendaTasks = async (agendaId) => {
  return await getData(url.GET_MEETING_AGENDATASKS + "/" + agendaId);
};

export const getAgendaNotes = async (agendaId) => {
  return await getData(url.GET_MEETING_AGENDANOTES + "/" + agendaId);
};

export const getNotesDetail = async (notesId) => {
  return await getData(url.GET_MEETING_NOTESDETAIL + "/" + notesId);
};

export const getNotesDocs = async (notesId) => {
  return await getData(url.GET_MEETING_NOTESDOCS + "/" + notesId);
};

export const getNotesTasks = async (notesId) => {
  return await getData(url.GET_MEETING_NOTESTASKS + "/" + notesId);
};

export const getMeetingTasks = async (meetingId) => {
  return await getData(url.GET_MEETING_TASKS + "/" + meetingId);
};

export const meetingSearch = async (_data) => {
  return await postData(url.POST_MEETING_SEARCH, _data);
};

export const meetingPublish = async (_data) => {
  return await postData(url.POST_MEETING_PUBLISH, _data);
};

//Document Search
export const documentSearch = async (_data) => {
  return await postData(url.POST_DOCUMENT_SEARCH, _data);
};

export const getFolderDocuments = async (folderId) => {
  return await getData(url.GET_FOLDER_DOCUMENTS + "/" + folderId);
};

export const getAllDocuments = async () => {
  return await getData(url.GET_ALL_DOCUMENTS);
};

export const getDocumentFiles = async (docId) => {
  return await getData(url.GET_DOCUMENT_FILES + "/" + docId);
};

export const getDocumentDetails = async (docId) => {
  return await getData(url.GET_DOCUMENT_DETAILS + "/" + docId);
};

export const documentAddTag = async (_data) => {
  return await postData(url.POST_DOCUMENT_ADDTAG, _data);
};

export const documentDeleteTag = async (_data) => {
  return await postData(url.POST_DOCUMENT_DELETETAG, _data);
};

export const getDocumentTags = async (docId) => {
  return await getData(url.GET_DOCUMENT_TAGS + "/" + docId);
};

export const documentAddProperty = async (_data) => {
  return await postData(url.POST_DOCUMENT_ADDPROPERTY, _data);
};

export const documentDeleteProperty = async (_data) => {
  return await postData(url.POST_DOCUMENT_DELETEPROPERTY, _data);
};

export const getDocumentProperties = async (docId) => {
  return await getData(url.GET_DOCUMENT_PROPERTIES + "/" + docId);
};

export const getDocumentComments = async (docId) => {
  return await getData(url.GET_DOCUMENT_COMMENTS + "/" + docId);
};

//job start
export const triggerOCRJob = async (_data) => {
  return await postData(url.POST_TRIGGER_OCRJOB, _data);
};

//Login request
export const postLoginRequest = async (data) => {
  return await postData(url.LOGIN_URL, data);
};

export const postOTPRequest = async (data) => {
  return await postData(url.OTP_URL, data);
};

export const resendOTPRequest = async () => {
  return await postData(url.RESEND_OTP_URL, {});
};

//workflow - Tasks
export const getWorkflows = async () => {
  return await getData(url.GET_WORKFLOW_WORKFLOWS);
};

//users
export const getUsersList = () => {
  return getData("/User/users");
};

export const getInvitableUsersList = () => {
  return getData("/User/invitableusers");
};

export const addUserDetail = async (userdata) => {
  return await postData("/User/adduser", userdata);
};

export const updateUserDetail = async (userdata) => {
  return await postData("/User/updateuser", userdata);
};

export const updateUserCredential = async (data) => {
  return await postData("/User/updatecredentials", data);
};

export const changePassword = async (data) => {
  return await postData("/User/changepassword", data);
};

export const getuserById = async (id) => {
  return await getData("/User/userdetail/" + id);
};

// Inspection cycle list

//PROJECTS - INSPECTION CYCLE

export const searchInspectionCycles = async (data) => {
  return await postData(url.POST_INSPECTION_CYCLE_SEARCH, data);
};

export const searchClients = async () => {
  return await postData(url.POST_CLIENT_SEARCH, {});
};

export const createUpdateClient = async (data) => {
  return await postData(url.CREATEUPDATE_CLIENT, data);
};

export const getClientDetail = async (clientId) => {
  return await getData(url.GET_CLIENT_DETAIL + "/" + clientId);
};

export const getNextClientCode = async () => {
  return await getData(url.GET_NEXT_CLIENT_CODE);
};

export const deleteClient = async (clientId) => {
  return await deleteData(`${url.DELETE_CLIENT}/${clientId}`);
};

export const saveInspectionCycle = async (data) => {
  return await postData(url.SAVE_INSPECTION_CYCLE, data);
};

export const updateInspectionCycle = async (data) => {
  return await postData(url.UPDATE_INSPECTION_CYCLE, data);
};

export const getInspectionCycle = async (inspectionCycleId) => {
  return await getData("/inspectioncycle/detail/" + inspectionCycleId);
};

export const getInspectionCycleComments = async (inspectionCycleId) => {
  return await getData("/inspectioncycle/comments/" + inspectionCycleId);
};

export const getInspectionCycleDocuments = async (inspectionCycleId) => {
  return await getData("/inspectioncycle/documents/" + inspectionCycleId);
};

export const getInspectionCycleActivityList = async (inspectionCycleId) => {
  return await getData("/inspectioncycle/activitylist/" + inspectionCycleId);
};

export const archiveInspectionCycle = async (inspectionCycleId) => {
  return await postData(
    "/inspectioncycle/" + inspectionCycleId + "/archive",
    {}
  );
};

export const getInspectionCycleEngagements = async (inspectionCycleId) => {
  return await getData(
    url.GET_INSPECTION_CYCLE_ENGAGEMENTS + "/" + inspectionCycleId
  );
};

//settings index
export const getIndexDetails = async () => {
  return await getData("/document/indexdetails");
};

//Application
export const getApplicationRoles = async () => {
  return await getData(url.GET_ROLES);
};

export const getApplicationCertificates = async () => {
  return await getData(url.GET_CERTIFICATES);
};

export const getApplicationNotifications = async () => {
  return await getData(url.GET_NOTIFICATIONS);
};

//Company
export const getCompanyList = async (id) => {
  return await getData(url.GET_COMPANY_LIST);
};

export const getCompanyRelatedList = async (id) => {
  return await getData(url.GET_COMPANY_RELATEDLIST + "/" + id);
};

export const getCompanyDetails = async (id) => {
  return await getData(url.GET_COMPANY_DETAILS + "/" + id);
};

export const getCompanyGroups = () => {
  return getData(url.GET_GROUPS);
};

export const createGroup = async (data) => {
  return await postData(url.CREATE_GROUP, data);
};

export const getCompanyDesignations = () => {
  return getData(url.GET_DESIGNATIONS);
};

export const getDesignationDetail = (id) => {
  return getData(url.GET_DESIGNATIONDETAIL + "/" + id);
};

export const submitDesignation = async (data) => {
  return await postData(url.POST_DESIGNATION, data);
};

export const getReviewTypes = (includeInactive = false) =>
  getData(
    `/master/inspectionreviewtypes${
      includeInactive ? "?includeInactive=true" : ""
    }`
  );
export const createUpdateReviewType = (data) =>
  postData("/master/inspectionreviewtypes", data);

export const saveInspectionChecklistScope = (inspectionId, checklistId, questionIds) =>
  putData(`/inspection/${inspectionId}/checklists/${checklistId}/scope`, { questionIds });
